import { gql } from '@apollo/client';

export const PATCH_PREREQUISITE_MUTATION = gql`
    mutation patchPrerequisiteSet( $input:PatchPrerequisiteSetInput! ) {
        Result: patchPrerequisiteSet( input:$input ) {
            id
            objectId
            operator
            type
            prerequisites {
                objectId
                weight
            }
        }
    }`
;